import { render, staticRenderFns } from "./cardUpload.vue?vue&type=template&id=04bb3a9f&"
import script from "./cardUpload.vue?vue&type=script&lang=js&"
export * from "./cardUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zhishengluo/opp-scratch/scratch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04bb3a9f')) {
      api.createRecord('04bb3a9f', component.options)
    } else {
      api.reload('04bb3a9f', component.options)
    }
    module.hot.accept("./cardUpload.vue?vue&type=template&id=04bb3a9f&", function () {
      api.rerender('04bb3a9f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload/cardUpload.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/upload/cardUpload.vue
// module id = 7jS/
// module chunks = 0